import styled from 'styled-components';

const TitleAndBreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin-bottom: 32px;
`;

export default TitleAndBreadcrumbContainer;
